var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { "align-baseline": "", "justify-space-between": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs4: "", md2: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.warehousesSites,
                  "item-text": "siteName",
                  "item-key": "key",
                  "return-object": "",
                  label: _vm.$t("warehouseSite")
                },
                model: {
                  value: _vm.currentWarehouseSite,
                  callback: function($$v) {
                    _vm.currentWarehouseSite = $$v
                  },
                  expression: "currentWarehouseSite"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs4: "", md2: "" } },
            [
              _c("v-switch", {
                attrs: {
                  label: _vm.$t(_vm.isInbound ? "inbound" : "outbound")
                },
                model: {
                  value: _vm.isInbound,
                  callback: function($$v) {
                    _vm.isInbound = $$v
                  },
                  expression: "isInbound"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs4: "", md2: "" } },
            [
              _c("v-switch", {
                attrs: { label: _vm.$t("sound") },
                on: { change: _vm.setSoundToggle },
                model: {
                  value: _vm.soundToggle,
                  callback: function($$v) {
                    _vm.soundToggle = $$v
                  },
                  expression: "soundToggle"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs4: "", md2: "" } },
            [
              _c("v-checkbox", {
                attrs: { label: _vm.$t("alwaysForceAdd") },
                on: { change: _vm.setAlwaysForceAdd },
                model: {
                  value: _vm.alwaysForceAdd,
                  callback: function($$v) {
                    _vm.alwaysForceAdd = $$v
                  },
                  expression: "alwaysForceAdd"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c(
                "v-btn",
                {
                  staticStyle: { "font-size": "42px!important" },
                  attrs: {
                    dark: "",
                    large: "",
                    color: "blue",
                    title: _vm.$t("total")
                  }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.trackings.length) + "\n        "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "text-xs-right", attrs: { xs4: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { dark: "", color: "red" },
                  on: { click: _vm.clearAllTrackings }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("clear")) + "\n      ")]
              ),
              _vm._v(" "),
              _c("LoaderButton", {
                attrs: {
                  buttonText: _vm.$t("submit"),
                  promiseAwait: _vm.uploadScannedTrackings
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "align-baseline": "", "justify-space-between": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs6: "" } },
            [
              _c(
                "v-radio-group",
                {
                  attrs: { column: false },
                  model: {
                    value: _vm.carrier,
                    callback: function($$v) {
                      _vm.carrier = $$v
                    },
                    expression: "carrier"
                  }
                },
                _vm._l(Object.entries(_vm.carrierMap), function(item) {
                  return _c("v-radio", {
                    key: item[0],
                    attrs: { label: "" + item[1], value: item[0] }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider", {
            staticStyle: { margin: "12px 0px", "border-width": "1px" },
            attrs: { vertical: "" }
          }),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs4: "" } },
            [
              _c(
                "v-radio-group",
                {
                  attrs: { column: false },
                  model: {
                    value: _vm.serviceType,
                    callback: function($$v) {
                      _vm.serviceType = $$v
                    },
                    expression: "serviceType"
                  }
                },
                _vm._l(Object.entries(_vm.serviceTypeMap), function(item) {
                  return _c("v-radio", {
                    key: item[0],
                    attrs: { label: "" + item[1], value: item[0] }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            { attrs: { xs6: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label:
                    _vm.$t("inputTrackingHere") +
                    (_vm.forceMode ? "(force " + _vm.forceMode + " mode)" : ""),
                  hint: _vm.$t("preScanHint"),
                  outline: !!_vm.forceMode,
                  autofocus: ""
                },
                on: {
                  keyup: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.addBarcode.apply(null, arguments)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        $event.keyCode !== 84
                      ) {
                        return null
                      }
                      if (!$event.altKey) {
                        return null
                      }
                      return _vm.forceAddTracking.apply(null, arguments)
                    }
                  ]
                },
                model: {
                  value: _vm.barcode,
                  callback: function($$v) {
                    _vm.barcode = $$v
                  },
                  expression: "barcode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        _vm._l(_vm.trackings, function(item) {
          return _c(
            "v-flex",
            { key: item, attrs: { xs4: "" } },
            [
              _c(
                "v-chip",
                {
                  attrs: { close: "" },
                  on: {
                    input: function($event) {
                      return _vm.onDeleteChip(item)
                    }
                  }
                },
                [_vm._v(_vm._s(item))]
              )
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "mt-3": "" } },
        [
          _c(
            "v-flex",
            [
              _c("v-textarea", {
                staticClass: "thinBox",
                attrs: { outline: "", label: _vm.$t("note"), rows: "2" },
                model: {
                  value: _vm.note,
                  callback: function($$v) {
                    _vm.note = $$v
                  },
                  expression: "note"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c("UploadFileWidget", {
            ref: "fileUploader",
            attrs: { type: "comments", maxFiles: 10 },
            model: {
              value: _vm.uploadedFiles,
              callback: function($$v) {
                _vm.uploadedFiles = $$v
              },
              expression: "uploadedFiles"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e93de0e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e93de0e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrescanMainTab.vue
// module id = null
// module chunks = 